export const postcodeRegexp = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
